import Icon from "../Domain/Icon";

export const Icons:Icon[] = [
    new Icon("buffalo", "/Icons/buffalo.svg"),
    new Icon("chicken", "/Icons/chicken.svg"),
    new Icon("cow", "/Icons/cow.svg"),
    new Icon("duck", "/Icons/duck.svg"),
    new Icon("lamb", "/Icons/lamb.svg"),
    new Icon("moose", "/Icons/moose.svg"),
    new Icon("rabbit", "/Icons/rabbit.svg"),
    new Icon("salmon", "/Icons/salmon.svg"),
    new Icon("turkey", "/Icons/turkey.svg"),
]
